module.exports = __webpack_public_path__ + "img/Bingo2_Asset_Info_Web_1.c717222f.png";